import type { GraphViewNode } from '@/types/graph-view'

/** A node in the shape the graph views keep in their data before mapping it to the canvas. */
export interface CanvasNode {
  id: string
  name: string
  labels: string[]
  typeLabel?: string
  properties?: Record<string, unknown>
}

/** A just-created entity as a canvas node (its name falls back to its id). */
export function manualEntityAsNode(entity: GraphViewNode): CanvasNode {
  return {
    id: entity.id,
    name: entity.name ?? entity.id,
    labels: entity.labels,
    typeLabel: entity.typeLabel,
    properties: entity.properties,
  }
}
